<template>

    <figure class="content-hiv-info-graphic">
        <div class="aspect-ratio-box">
            <div class="aspect-ratio-box-inner">
                <div class="content-hiv-info-graphic-background">

                    <div
                            class="content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-0"
                            v-on:click="toggleOverlay(0)"
                    ></div>
                    <div
                            class="content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-1"
                            v-on:click="toggleOverlay(1)"
                    ></div>
                    <div
                            class="content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-2"
                            v-on:click="toggleOverlay(2)"
                    ></div>
                    <div
                            class="content-hiv-info-graphic-toggle content-hiv-info-graphic-toggle-3"
                            v-on:click="toggleOverlay(3)"
                    ></div>

                    <div
                            class="content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-0"
                            v-bind:style="{ opacity: overlayIndex === 0 ? 1 : 0 }"
                    >
                        <h4>Fusions-Hemmer</h4>
                        <p>
                            auch Eintritts-Hemmer genannt, verhindern entweder das Andocken der Viren auf der Wirtszelle oder
                            das nachfolgende Eindringen in die Wirtszelle selbst.
                        </p>
                    </div>

                    <div
                            class="content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-1"
                            v-bind:style="{ opacity: overlayIndex === 1 ? 1 : 0 }"
                    >
                        <h4>Reverse Transkriptase-Hemmer:</h4>
                        <p>
                            Das Virus muss seine Erbinformation – die Virus-RNA – mithilfe des Enzyms Reverse-Transkriptase in
                            DNA umschreiben. Sonst kann diese nicht in die Erbinformation der Wirtszelle eingebaut werden.
                            Dieser Umschreibe-Prozess lässt sich medikamentös stören. Diese Medikamente heißen Nukleosidale bzw.
                            Nukleosidanaloge Reverse-Transkriptase-Hemmer (NRTIs). Am selben Punkt der Virusvermehrung setzen
                            die Nicht-Nukleosidalen bzw. Nicht-Nukleosidanalogen Reverse-Transkriptase-Hemmer, sogenannte NNRTIs
                            an. Sie blockieren das Enzym direkt, sodass der Prozess des Umschreibens der Erbinformation
                            unmittelbar verhindert wird.
                        </p>
                    </div>

                    <div
                            class="content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-2"
                            v-bind:style="{ opacity: overlayIndex === 2 ? 1 : 0 }"
                    >
                        <h4>Integrase-Inhibitoren</h4>
                        <p>
                            behindern die Virusvermehrung, indem sie den Einbau – die Integration – der neu geschriebenen
                            Virus-DNA in die menschliche DNA verhindern.
                        </p>
                    </div>

                    <div
                            class="content-hiv-info-graphic-overlay content-hiv-info-graphic-overlay-3"
                            v-bind:style="{ opacity: overlayIndex === 3 ? 1 : 0 }"
                    >
                        <h4>Protease-Hemmer blockieren</h4>
                        <p>
                            ein virales Enzym, die „Protease“. Auch die Protease hat das HI-Virus mit in die Wirtszelle
                            gebracht. Wird die Protease gehemmt, können keine neuen HI-Viren entstehen.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    </figure>

</template>

<script>

    // console.log('ContentHivInfoGraphic');

    export default {
        components : {},
        data(){
            return {
                overlayIndex : 0,
            };
        },
        methods : {
            toggleOverlay(index){
                this.overlayIndex = index;
            },
        },
    }

</script>

<style lang="scss">

    @import '../../../css/variables';

    .content-hiv-info-graphic {
        .content-hiv-info-graphic-background {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-image: url(/media/content_hiv_info_graphic.png);
            background-position: 100% 50%;
            background-repeat: no-repeat;
            background-size: contain;
        }
        .content-hiv-info-graphic-toggle {
            position: absolute;
            width: 4%;
            height: 4%;
            /*background-color: rgba(0, 0, 0, .25);*/
            cursor: pointer;
            &.content-hiv-info-graphic-toggle-0 {
                left: 34.25%;
                top: 13.75%;
            }
            &.content-hiv-info-graphic-toggle-1 {
                left: 34.25%;
                top: 37.5%;
            }
            &.content-hiv-info-graphic-toggle-2 {
                left: 34.25%;
                top: 52.5%;
            }
            &.content-hiv-info-graphic-toggle-3 {
                left: 34.25%;
                top: 66.25%;
            }
        }
        .content-hiv-info-graphic-overlay {
            position: absolute;
            left: 2%;
            width: 30.25%;
            opacity: 0;
            transition: opacity 400ms;
            will-change: opacity;
            &.content-hiv-info-graphic-overlay-0 {
                top: 13.75%;
            }
            &.content-hiv-info-graphic-overlay-1 {
                top: 37.5%;
            }
            &.content-hiv-info-graphic-overlay-2 {
                top: 52.5%;
            }
            &.content-hiv-info-graphic-overlay-3 {
                top: 66.25%;
            }
            p {
                margin: 0;
                font-size: 1rem;
                text-align: right;
                @media screen and (max-width: 767px) {
                    font-size: 1rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 1rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1rem * $factor-2400;
                }
            }
            h4 {
                margin: 4% 0 0 0;
                font-size: 1rem;
                font-weight: bold;
                text-align: right;
                @media screen and (max-width: 767px) {
                    font-size: 1rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 1rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1rem * $factor-2400;
                }
            }
        }
    }

</style>
